import baseUrl from './baseUrl';

const ENDPOINT = `${baseUrl}/acoesterritoriais/usuario`;

export const usuariosATService = {
    async get(id) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        const response = await data.json();

        return response;
    },
    async update(id, values) {
        const data = await fetch(`${ENDPOINT}/${id}`, {
            method: 'PUT',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(values)
        });

        const response = await data.json();
        return response;
    },
    async delete(id) {
        const response = await fetch(`${ENDPOINT}/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        });

        return response;
    },
    async create(data) {
        const response = await fetch(ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        });

        return response;
    },
}